import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SHARED_CONSTANT } from "../../service/constant/shared.constant";
@Injectable({
  providedIn: "root",
})
export class DoumentsServiceService {
  constructor(private http: HttpClient) {}
  public getImage(doc) {
    return this.http.get(
      `${SHARED_CONSTANT.DOCUMENT_DOWNLOAD}${doc.filename}`,
      {
        responseType: "blob",
      }
    );
  }
}
